import { Component, computed, input, output, signal, ViewChild } from '@angular/core';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';

import {
  compareCropFieldByAdvice,
  compareCropFieldByLastSprayDate,
  compareCropFieldByName,
  CropFieldComparator,
  SortMethodType,
} from '../helpers/sort.helpers';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@next/core-lib/i18n';


interface MenuItem {
  name: string;
  type: SortMethodType;
  sortMethod: CropFieldComparator;
}

@Component({
    selector: 'app-disease-sort-menu',
    styleUrl: '../table.component.scss',
    template: `
    <button mat-flat-button class="table-toolbar-button" (click)="menuTrigger.openMenu()">
      <span class="flex--align-center table-toolbar-button-span">
        {{ selectedSortMethod().name | translate }}
        <mat-icon>keyboard_arrow_down</mat-icon>
      </span>
    </button>
    <div [matMenuTriggerFor]="sortMenu">
      <mat-menu #sortMenu="matMenu">
        @for (sortMethod of filteredSortMethods(); track sortMethod) {
          <button mat-menu-item (click)="onSortMethodSelected(sortMethod.sortMethod)">
            <span [class.text--bold]="isSelectedOption(sortMethod)">{{ sortMethod.name | translate }}</span>
          </button>
        }
      </mat-menu>
    </div>
  `,
    imports: [
        MatButton,
        MatIcon,
        MatMenuTrigger,
        MatMenu,
        MatMenuItem,
        TranslatePipe,
    ],
})
export class SortMenuComponent {
  @ViewChild(MatMenuTrigger) public menuTrigger!: MatMenuTrigger;

  public readonly availableSortMethods = input<SortMethodType[]>([SortMethodType.Name, SortMethodType.Advice, SortMethodType.Spray]);
  public readonly sortMethodSelected = output<CropFieldComparator>();

  protected readonly sortMethods: MenuItem[] = [
    { name: 'shared.diseaseTable.sort.name', type: SortMethodType.Name, sortMethod: compareCropFieldByName },
    { name: 'shared.diseaseTable.sort.advice', type: SortMethodType.Advice, sortMethod: compareCropFieldByAdvice },
    { name: 'shared.diseaseTable.sort.spray', type: SortMethodType.Spray, sortMethod: compareCropFieldByLastSprayDate },
  ];

  protected readonly filteredSortMethods = computed(() =>
    this.sortMethods.filter((method) => this.availableSortMethods().includes(method.type)),
  );

  protected readonly selectedSortMethod = signal<MenuItem>(this.sortMethods[0]);

  protected onSortMethodSelected(sortMethod: CropFieldComparator): void {
    this.selectedSortMethod.set(this.sortMethods.find((item) => item.sortMethod === sortMethod)!);
    this.sortMethodSelected.emit(sortMethod);
  }

  protected isSelectedOption(option: MenuItem): boolean {
    return this.selectedSortMethod().name === option.name;
  }
}
